"use client";

import { SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Typography } from "@/components/ui/typography";
import { useTranslation } from "@/i18n/client";

interface SignOutDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSigningOut: boolean;
}

export function SignOutDialog({ isOpen, onClose, onConfirm, isSigningOut }: SignOutDialogProps) {
  const { t: tSidebar } = useTranslation("sidebar");

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] bg-white p-5">
        <div className="flex flex-col">
          <DialogHeader>
            <div className="flex items-start mb-0">
              <div className="p-2 bg-error-100 rounded-full mr-3 flex-shrink-0">
                <SignOut size={20} className="text-error-400" />
              </div>
              <div className="flex-1">
                <DialogTitle className="mb-0">
                  <Typography variant="heading 3" className="text-neutral-700">
                    {tSidebar("signOutConfirmTitle")}
                  </Typography>
                </DialogTitle>
                <DialogDescription>
                  <Typography variant="body 1" className="text-neutral-600">
                    {tSidebar("signOutConfirmDescription")}
                  </Typography>
                </DialogDescription>
              </div>
            </div>
          </DialogHeader>
          <DialogFooter className="mt-6 justify-end">
            <Button variant="outline" onClick={onClose} disabled={isSigningOut}>
              {tSidebar("cancel")}
            </Button>
            <Button
              variant="primary"
              onClick={onConfirm}
              disabled={isSigningOut}
              className="bg-red-500 hover:bg-red-600"
            >
              {isSigningOut ? `${tSidebar("signingOut")}...` : tSidebar("confirmSignOut")}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
